export class ComboFuncionario {
	id: number;
	nome: string;
	descricao: string;
}